/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Link } from 'gatsby';
import styled from '@emotion/styled';
import { paddingLeftRight } from './styles';
import { colors } from '../../theme';
import { capitalCase } from 'change-case';

const topBottomPadding = css`
  padding-top: 3px;
  padding-bottom: 3px;
  text-decoration: none;
`;

export const HitsWrapper = styled.div`
  left: 0;
  display: flex;
  flex-direction: column;
  overflow: auto;
  z-index: 2;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  margin-top: 10px;
  text-decoration: none !important;
  > * + * {
    border-top: 2px solid ${(props) => props.theme.search.border};
  }
  li {
    ${topBottomPadding};
    ${paddingLeftRight};
    &:hover {
      background-color: ${(props) => props.theme.search.hover};
      color: ${(props) => props.theme.search.font.hover};
    }
  }
  li + li {
    border-top: 1px solid ${(props) => props.theme.search.border};
  }
  * {
    text-decoration: none;
    margin-top: 0;
    color: ${(props) => props.theme.search.font.base};
  }
  a {
    margin: 1px;
  }
  ul {
    list-style: none;
  }
  mark {
    color: ${(props) => props.theme.search.mark.font};
    background: ${colors.primaryDark2};
  }
`;

const HitTitle = styled.div`
  font-weight: bold;
  padding-top: 2px;
  padding-bottom: 2px;
  font-size: 15px;
`;

const HitDetails = styled.div`
  padding-top: 2px;
  padding-bottom: 2px;
  font-size: 14px;
`;

export const Hit = (hit) => {
  const pathParts = hit.slug.split('/');
  const title = hit.title.props.hit.title || capitalCase(pathParts[pathParts.length - 1]);

  return (
    <Link to={hit.slug}>
      <HitTitle>{title}</HitTitle>
      <HitDetails>{hit.details}</HitDetails>
    </Link>
  );
};
